<div class="top-nav-pageTitle">
    {{title}}
    <i class="material-icons pullfloat-right" (click)="close()"  title="close">close</i>
</div>
<div class="component-wrapper">

    <form class="form-horizontal" [formGroup]="feedbackForm">
        <div class="form-group row" [ngClass]="displayFieldCss('firstName')">
            <div class="col-md-4 from-label" >
                <label for="firstName" class="control-label required">FIRST NAME *</label>
            </div>
            <div class="col-md-8">
                <input type="text" id="firstName" class="form-control" formControlName="firstName">
            </div>
            <div class="col-md-8 offset-md-4 error-msg" *ngIf="isFieldValid('firstName')">
                Please inform your first name
            </div>
        </div>

        <div class="form-group row" [ngClass]="displayFieldCss('lastName')">
            <div class="col-md-4 from-label">
                <label for="lastName" class="control-label required">LAST NAME *</label>
            </div>
            <div class="col-md-8">
                <input type="text" id="lastName" class="form-control" formControlName="lastName">
            </div>
            <div class="col-md-8 offset-md-4 error-msg" *ngIf="isFieldValid('lastName')">
                Please inform your last name
            </div>
        </div>

        <div class="form-group row" [ngClass]="displayFieldCss('email')">
            <div class="col-md-4 from-label">
                <label for="email" class="control-label required">EMAIL *</label>
            </div>
            <div class="col-md-8">
                <input type="email" id="email" class="form-control" formControlName="email">
            </div>
            <div class="col-md-12 error-msg" *ngIf="isFieldValid('email')">
                <div class="col-md-8 offset-md-4 error-msg" *ngIf="feedbackForm.get('email').errors?.required">
                    Please enter your email address.
                </div>
                <div class="col-md-8 offset-md-4 error-msg" *ngIf="!feedbackForm.get('email').errors?.required && feedbackForm.get('email').errors?.email">
                    Please enter a valid email address.
                </div>
            </div>
        </div>

        <div class="form-group row" >
            <div class="col-md-4 from-label">
                PHONE
            </div>
            <div class="col-md-8">
                <input type="text" id="phone" class="form-control" formControlName="phone">
            </div>
        </div>

        <div class="form-group row" [ngClass]="displayFieldCss('comments')">
            <div class="col-md-4 from-label">
                <label for="comments" class="control-label required">COMMENTS *</label>
            </div>
            <div class="col-md-8">
                <textarea id="comments" class="input no-border form-control" cols="20" id="comments" name="comments" rows="8" formControlName="comments"></textarea>
            </div>
            <div class="col-md-8 offset-md-4 error-msg" *ngIf="isFieldValid('comments')">
                    Please enter comments.
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-12">
                <button [disabled]="disableButton" type="button" id="send-feedback-button" class="button button-red button-mid confirmButton submitButton" (click)="onSubmit()">Send</button>
            </div>
        </div>
    </form>
    <div class="top-border-container autoflow-fix">
        If you’d like to provide an image with your feedback, please email <a style="color:blue" href="mailto:webmaster@dickerdata.com.au?subject=Dicker Data Website - Feedback">webmaster@dickerdata.com.au</a>
    </div>   
</div>

<!-- <ng-container *ngIf="showResult">
    <div class="result-wrapper">
        Thanks for your feedback!
    </div>
</ng-container>  -->